var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCenterWhite = function SvgCenterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M1.328 6.392V1.725c0-.368.299-.666.667-.666h4.667M1.328 11.725v4.667c0 .368.299.667.667.667h4.667M17.328 6.392V1.725a.667.667 0 0 0-.666-.666h-4.667M17.328 11.725v4.667a.667.667 0 0 1-.666.667h-4.667M5.328 9.057h8M9.328 13.059v-8"
  })));
};
export default SvgCenterWhite;